import { ReactElement, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useError } from '@hooks/useError'

const ErrorFallback = (): ReactElement | null => {
  const { error, previousUrl, clearError } = useError()
  const navigate = useNavigate()
  const location = useLocation()

  // Store error data in sessionStorage for the ErrorPage to access
  useEffect(() => {
    if (error) {
      sessionStorage.setItem('errorDisplay', JSON.stringify(error))
      // Store the previous URL with query parameters
      if (previousUrl) {
        sessionStorage.setItem('previousUrl', previousUrl)
      }
      // Navigate to error page
      navigate('/error', { replace: true })
    }
  }, [error, previousUrl, navigate])

  // Clear error when leaving error page
  useEffect(() => {
    if (location.pathname !== '/error' && error) {
      clearError()
    }
  }, [location.pathname, error, clearError])

  // This component doesn't render anything itself
  return null
}

export default ErrorFallback
